/**
 * Saved-state return from Theme / Logline leftovers back to Tasks (#1109).
 */

import { pathRoomPath } from './pathRoomPath';

export const BACK_TO_TASKS = 'Back to Tasks';

export function tasksReturnKey(storyId) {
  return storyId ? `brainstormy.handoff.returnTo.${storyId}` : '';
}

export function rememberTasksReturn(storyId) {
  const key = tasksReturnKey(storyId);
  const path = pathRoomPath(storyId);
  if (!key || !path || typeof sessionStorage === 'undefined') return path;
  try {
    sessionStorage.setItem(key, path);
  } catch {
    // Quota or private mode — navigate state still carries the return.
  }
  return path;
}

export function readTasksReturn(storyId) {
  const key = tasksReturnKey(storyId);
  if (!key || typeof sessionStorage === 'undefined') return '';
  try {
    return sessionStorage.getItem(key) || '';
  } catch {
    return '';
  }
}

export function clearTasksReturn(storyId) {
  const key = tasksReturnKey(storyId);
  if (!key || typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.removeItem(key);
  } catch {
    // ignore
  }
}
